import { useQuery } from "@tanstack/react-query";
import { bookingPolicyApi, bookingPolicyQueryKeys } from "../api/bookingPolicy";
import { ACTIVE_BRANCH_KEY } from "../api/branches";

function activeBranch(): string | undefined {
  try {
    return localStorage.getItem(ACTIVE_BRANCH_KEY) || undefined;
  } catch {
    return undefined;
  }
}

/**
 * #19665 — is Phòng = Bắt buộc ({@code dimRoom = REQUIRED}) for this branch? Drives the
 * "Bắt đầu khám" lock on Tiếp đón, Khám bệnh › Hàng chờ and Chi tiết lịch hẹn.
 *
 * <p>Fails OPEN on the screen: while loading, or when the caller may not read the policy, the
 * button stays as it was and the server's 422 {@code appointment_room_required} is what refuses.
 * Locking on an unknown answer would block every clinic whose staff lack {@code clinic.read}.
 *
 * <p>Keyed under {@code bookingPolicyQueryKeys.all()}, so saving Cài đặt → Đặt lịch invalidates it.
 */
export function useRoomRequired(branchId?: string): boolean {
  const branch = branchId || activeBranch();
  const q = useQuery({
    queryKey: [...bookingPolicyQueryKeys.all(), "room-required", branch ?? "default"],
    queryFn: () => bookingPolicyApi.get(branch),
    staleTime: 60_000,
    retry: false,
  });
  return q.data?.dimRoom === "REQUIRED";
}
